// Need underscore dangles for redux devtools support
/* eslint no-underscore-dangle: "off" */

import 'babel-polyfill'
import 'react-virtualized/styles.css'

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Router, Route } from 'react-router-dom'
import createSagaMiddleware from 'redux-saga'
import { createHashHistory } from 'history'
import WebFont from 'webfontloader'
import { createStore, combineReducers, compose, applyMiddleware } from 'redux'
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'
import { routerReducer, routerMiddleware } from 'react-router-redux'
import JssProvider from 'react-jss/lib/JssProvider'
import { createGenerateClassName } from '@material-ui/core/styles'
import Theme from './theme'
import { notificationOpen, notificationClose } from './common/actions'
import { hasMinWage } from './account/selectors'

/**
 * Add new modules here
 */
import AccountModule from './account'
import AppModule from './app'
import CommonModule from './common'
import ComplianceModule from './compliance'
import DevModule from './dev'
import MinWageModule from './minWage'
import PaidLeaveModule from './paidLeave'
import EmailNotificationRenderer from './minWage/components/emailNotification'
// import MaintenancePage from '../source/account/components/maintenance/maintenancePage'

import { GlobalStyle } from './theme/Global'


// https://mathiasbynens.be/notes/globalthis
// The polyfill starts here.
!(function () {
  if (typeof globalThis === 'object') return
  Object.defineProperty(Object.prototype, '__magic__', {
    get() {
      return this
    },
    configurable: true
  })
  __magic__.globalThis = __magic__
  delete Object.prototype.__magic__
}())
// The polyfill ends here.

WebFont.load({ google: { families: ['Open Sans:300,400,500,600,800', 'sans-serif'] } })

const generateClassName = createGenerateClassName({
  dangerouslyUseGlobalCSS: false,
  productionPrefix: 'mui'
})

const modules = [DevModule, AppModule, CommonModule, ComplianceModule, MinWageModule, PaidLeaveModule, AccountModule]
/**
 * End adding new module
 */

// Load Reducers
const reducers = { router: routerReducer }
modules.forEach((module) => {
  if (module.reducer) {
    reducers[module.constants.NAME] = module.reducer
  }
})

// Start history
const history = createHashHistory()
const historyMiddleware = routerMiddleware(history)

// Load state store
const sagas = createSagaMiddleware()

// Add support for Redux DevTools extension, if enabled
// TODO: Ideally move Redux DevTools integration to 'dev' module
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(
  combineReducers(reducers),
  composeEnhancers(applyMiddleware(sagas, historyMiddleware))
)

// Run Sagas
modules.forEach((module) => {
  if (module.saga) {
    sagas.run(module.saga)
  }
})

history.listen((location) => {
  if (location.pathname !== '/' && location.pathname !== '/reset-password' && location.pathname !== '/login') {
    store.dispatch(notificationClose())
    const route = location.pathname
    const state = store.getState()
    const banner = state.account.user ? state.account.user.banner_notifications : null
    const preferences = state.account.user ? state.account.user.user_preferences : null

    if (banner) {
      if (hasMinWage(state) && route.toLowerCase().includes('minwage') && banner.find((banner) => banner.name === 'email_notifications') === undefined && preferences.find((pref) => pref.name === 'email_notifications') === undefined) {
        if (window.sessionStorage.getItem('email_banner') === '') {
          store.dispatch(notificationOpen({ component: (<EmailNotificationRenderer />) }))
          window.sessionStorage.setItem('email_banner', 'shown')
        }
      }
    }
  }
})

document.body.innerHTML += '<div id="app"></div>'

ReactDOM.render(
  <JssProvider generateClassName={generateClassName}>
    <Provider store={store}>
      <MuiThemeProvider theme={Theme}>
        <Router history={history}>
          <GlobalStyle />
          <div>
            <Route path="/" component={AppModule.components.app} />
            {/* <MaintenancePage /> */}
          </div>
        </Router>
      </MuiThemeProvider>
    </Provider>
  </JssProvider>,
  document.getElementById('app')
)
